import type { UnitEconomicsSnapshot } from '../types';

const getMockUnitEconomics = (): UnitEconomicsSnapshot => ({
    ltvCents: 842000,
    cacCents: 280000,
    ltvToCacRatio: 3,
    paybackMonths: 5,
    grossMarginPercent: 19,
});

export default getMockUnitEconomics;
